import React, { useEffect, useState } from "react";
import { useLanguage } from "../pages/LanguageContext";
import Mass from "../images/Mass Logo Reconstructed.png";
import HeroBg from "../images/ut.jpg";
import HeroBgMobile from "../images/photo_2025-06-22_10-14-43.jpg";
import Life1 from "../images/Damac.jpg";
import Life2 from "../images/vibranum.jpg";
import Life3 from "../images/TCF.png";
import Life4 from "../images/Alshafi.jpg";

const brandBlue = "#1a4bb7";
const accentBlue = "#2297e6";
const lightBlueBG = "#f5faff";

const translations = {
  en: {
    heroTitle: (
      <>
        Your Space,{" "}
        <span
          style={{
            background: `linear-gradient(90deg, ${brandBlue} 0%, ${accentBlue} 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 900,
          }}
        >
          Superpowered
        </span>
      </>
    ),
    heroSubtitle:
      "From Amman to Dubai, we’re shaping the future of smart living — where comfort, control, and security come together seamlessly.",
    badges: ["Simple", "Secure", "Sustainable"],
    whyMass: "Why Mass ?",
    whyMassPoints: [
      "Over 100+ satisfied clients in Jordan & UAE",
      "Tailored solutions for every home and office",
      "Award-winning innovation & reliability",
      "Premium support and aftercare",
      "Official partner with global smart tech brands",
    ],
    visionTitle: "Our Vision",
    visionText:
      "To lead the region in smart living — shaping connected, energy-efficient homes of the future, where comfort and security are always within reach.",
    journeyTitle: "Our Journey",
    milestones: [
      {
        year: "2019",
        title: "Established",
        desc: "Mass Smart Solutions was founded with a clear vision: bringing smart technology into everyday living",
      },
      {
        year: "2022",
        title: "Official Launch",
        desc: "Following successful early projects, we marked our official launch — setting the foundation for scalable, professional smart home solutions.",
      },
      {
        year: "2024",
        title: "100 Projects Completed",
        desc: "A major milestone: over 100 homes and offices transformed into fully intelligent spaces.",
      },
      {
        year: "2025",
        title: "Expansion to Dubai",
        desc: "Entering the UAE market with confidence, bringing our expertise to the Gulf region.",
      },
    ],
    diffTitle: "What Makes Us Different?",
    difference: [
      {
        icon: "🚀",
        title: "Fast Installation",
        desc: "Most systems live within a day. Zero mess, zero stress.",
      },
      {
        icon: "🔒",
        title: "Proven Security",
        desc: "Military-grade encryption, 24/7 monitoring, real peace of mind.",
      },
      {
        icon: "🎨",
        title: "Design-First",
        desc: "Our engineers work with your architect, not against them.",
      },
      {
        icon: "🤖",
        title: "Future-Proof Tech",
        desc: "Always compatible with the next big thing—guaranteed.",
      },
    ],
    lifeTitle: "Life At Mass",
    lifePhotos: [Life1, Life2, Life3, Life4],
    lifeDesc: (
      <>
        <span
          style={{ color: brandBlue, fontWeight: 800, fontSize: "1.13rem" }}
        >
          Work. Grow. Celebrate.
        </span>
        <br />
        At Mass, our people are family—curious, creative, and always connected.
      </>
    ),
  },
  ar: {
    heroTitle: (
      <>
        مساحتك،{" "}
        <span
          style={{
            background: `linear-gradient(90deg, ${brandBlue} 0%, ${accentBlue} 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 900,
          }}
        >
          الذكية
        </span>
      </>
    ),
    heroSubtitle:
      "من عمّان إلى دبي، نعيد تعريف الحياة الذكية حيث يجتمع الراحة والتحكم والأمان في تجربة واحدة متكاملة",
    badges: ["بسيطة", "آمنة", "مستدامة"],
    whyMass: "لماذا ماس؟",
    whyMassPoints: [
      "أكثر من 100 عميل راضٍ في الأردن والإمارات",
      "حلول مخصصة لكل منزل ومكتب",
      "ابتكار وجوائز في الموثوقية",
      "دعم وخدمة متميزة لما بعد البيع",
      "شريك رسمي مع علامات التقنية الذكية العالمية",
    ],
    visionTitle: "رؤيتنا",
    visionText:
      "أن نقود المنطقة في العيش الذكي — نحو منازل متصلة وموفرة للطاقة حيث الراحة والأمان دائمًا في متناول اليد",
    journeyTitle: "رحلتنا",
    milestones: [
      {
        year: "2019",
        title: "التأسيس",
        desc: "تأسست Mass Smart Solutions برؤية واضحة: تحويل التكنولوجيا الذكية إلى جزء من الحياة اليومية",
      },
      {
        year: "2022",
        title: "الانطلاقة الرسمية",
        desc: "بعد تنفيذ عدد من المشاريع الناجحة، أطلقنا هويتنا التجارية رسميًا، واضعين الأساس لحلول ذكية أكثر احترافية وقابلة للتوسع",
      },
      {
        year: "2024",
        title: "اكتمال 100 مشروع",
        desc: "إنجاز بارز: تحويل أكثر من 100 منزل ومكتب إلى مساحات ذكية متكاملة",
      },
      {
        year: "2025",
        title: "التوسع إلى دبي",
        desc: "نخوض سوق الإمارات بثقة، حاملين خبراتنا إلى الخليج",
      },
    ],
    diffTitle: "ما الذي يميزنا؟",
    difference: [
      {
        icon: "🚀",
        title: "تركيب سريع",
        desc: "معظم الأنظمة تُركب في يوم واحد. بدون فوضى أو قلق",
      },
      {
        icon: "🔒",
        title: "أمان مُثبت",
        desc: "تشفير عالي، مراقبة 24/7، وراحة بال حقيقية",
      },
      {
        icon: "🎨",
        title: "أولوية التصميم",
        desc: "مهندسونا يعملون مع المهندس المعماري وليس ضده",
      },
      {
        icon: "🤖",
        title: "تقنية مستقبلية",
        desc: "متوافقون دائمًا مع أحدث التطورات التقنية",
      },
    ],
    lifeTitle: "الحياة في ماس",
    lifePhotos: [Life1, Life2, Life3, Life4],
    leadershipQuote:
      "المنازل الذكية ليست مجرد أجهزة—هي تمنح العائلات وقتًا وراحة وثقة أكبر. هذه هي رسالتنا الحقيقية",
    leadershipName: "ياسر أحمد",
    leadershipRole: "المؤسس والمدير التنفيذي",
  },
};

const AboutUsPage = () => {
  const { language } = useLanguage();
  const t = translations[language] || translations.en;
  const isAr = language === "ar";

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 700);
  const [darkMode, setDarkMode] = useState(
    window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  useEffect(() => {
    document.body.style.background = lightBlueBG;
    document.body.style.overflowX = "hidden";
    const handleResize = () => setIsMobile(window.innerWidth <= 700);
    const matcher = window.matchMedia("(prefers-color-scheme: dark)");
    const updateDark = (e) => setDarkMode(e.matches);
    window.addEventListener("resize", handleResize);
    matcher.addEventListener("change", updateDark);
    setDarkMode(matcher.matches);
    return () => {
      document.body.style.background = "";
      document.body.style.overflowX = "";
      window.removeEventListener("resize", handleResize);
      matcher.removeEventListener("change", updateDark);
    };
  }, []);

  return (
    <main
      className={darkMode ? "dark" : ""}
      style={{
        fontFamily: isAr
          ? "'Cairo', 'Tajawal', Tahoma, Arial, sans-serif"
          : "'Segoe UI',sans-serif",
        color: darkMode ? "#fff" : brandBlue,
        direction: isAr ? "rtl" : "ltr",
      }}
    >
      <section
        className="about-hero"
        style={{
          position: "relative",
          width: "100%",
          minHeight: "60vh",
          background: `linear-gradient(100deg, rgba(26,75,183,0.72) 0%, rgba(34,151,230,0.32) 100%), url(${
            isMobile ? HeroBgMobile : HeroBg
          }) center/cover no-repeat`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "60vw",
            height: "100%",
            background: "rgba(255,255,255,0.07)",
            clipPath: "polygon(100% 0, 100% 100%, 0 70%, 0 0)",
            zIndex: 1,
          }}
        />
        <div
          style={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            maxWidth: 640,
            margin: "0 auto",
            background: "rgba(222, 215, 215, 0.18)",
            borderRadius: 32,
            padding: "2.7rem 2.5rem 2rem",
            boxShadow: `0 6px 48px ${brandBlue}24`,
            backdropFilter: "blur(7px)",
            WebkitBackdropFilter: "blur(7px)",
          }}
          className="about-hero-content"
        >
          {!isMobile && (
            <img
              src={Mass}
              alt="Mass Smart Solution"
              style={{
                height: 68,
                marginBottom: 18,
                filter: `drop-shadow(0 3px 10px ${accentBlue}99)`,
              }}
              className="about-hero-logo"
            />
          )}
          <h1 className="logo-gradient-title big-title">{t.heroTitle}</h1>
          <div
            style={{
              fontSize: "1.18rem",
              margin: "0 auto 1.3rem",
              fontWeight: 600,
              display: "flex",
              justifyContent: "center",
              gap: "1.2rem",
              flexWrap: "wrap",
            }}
          >
            {t.badges.map((badge, i) => (
              <span
                key={i}
                style={{
                  color: "black",
                  borderRadius: 14,
                  padding: "5px 26px",
                  fontWeight: 700,
                  fontSize: "1.13rem",
                  letterSpacing: ".01em",
                  border: darkMode ? "2.5px solid #fff" : "2.5px solid #dde7f7",
                  transition: "border 0.18s, background 0.18s",
                }}
              >
                {badge}
              </span>
            ))}
          </div>
          <p
            style={{
              fontSize: "1.12rem",
              color: darkMode ? "black" : "black",
              maxWidth: 560,
              margin: "0 auto",
              fontWeight: 500,
            }}
          >
            {t.heroSubtitle}
          </p>
        </div>
      </section>
      <section
        style={{
          padding: "4rem 1.5rem 3rem",
          fontFamily: isAr
            ? "'Cairo', 'Tajawal', sans-serif"
            : "'Segoe UI', sans-serif",
          direction: isAr ? "rtl" : "ltr",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            marginBottom: "2.5rem",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: isAr ? "1.2rem" : "1.2rem",
              flexDirection: isAr ? "row-reverse" : "row",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <h2
              className="logo-gradient-title big-title"
              style={{
                margin: 0,
                fontSize: "clamp(2.2rem, 5vw, 2.8rem)",
              }}
            >
              {isAr ? "من نحن" : "Who We Are"}
            </h2>
          </div>
        </div>

        <div
          style={{
            maxWidth: 900,
            margin: "0 auto",
            borderRadius: 24,
            padding: "2.4rem 2rem",
            boxShadow: `0 4px 28px ${brandBlue}15`,
            fontSize: "1.1rem",
            lineHeight: 1.85,
            fontWeight: 500,
            color: darkMode ? "#fff" : "#1a4bb7",
            textAlign: "start",
            animation: "fadeUp 1s ease forwards",
            opacity: 0,
            transform: "translateY(20px)",
            background: darkMode ? "#1a222f77" : undefined,
          }}
          className="who-we-are-content"
        >
          <p style={{ marginBottom: "1.7rem" }}>
            {isAr ? (
              <>
                نشأت ماس للحلول الذكية من إيمان عميق بأن التكنولوجيا يجب أن
                تتكيّف مع الإنسان، وليس العكس. انطلقت رحلتنا من عمّان برؤية
                طموحة وفهم عميق لمفهوم الحياة الذكية، بهدف جعل المنازل أكثر
                راحة، أماناً، وكفاءة ومع ازدياد الطلب، توسّعت خدماتنا وانتقلنا
                من المنازل الفردية إلى المشاريع العقارية الكبيرة، مكتسبين ثقة
                أكثر من ١٠٠ عميل في الأردن والإمارات. نفخر بخدمتنا لمساحات
                متنوعة، من الشقق الصغيرة إلى الفلل الفاخرة، وكل ذلك برؤية واحدة:
                تبسيط الحياة من خلال أنظمة ذكية مصممة بعناية نحن لا نقوم بتركيب
                الأجهزة فقط، بل نصنع تجارب متكاملة. تميزنا يكمن في البرمجة
                الشخصية، والتكامل السلس بين الأنظمة، والدعم المستمر في كل وقت.
                سواء كنت تبدأ بخطوة صغيرة أو تطمح لتجربة متكاملة، نحن هنا لنرتقي
                بمساحتك... ببساطة، أمان، واستدامة
              </>
            ) : (
              <>
                Mass Smart Solutions was born out of a belief that technology
                should adapt to people — not the other way around. Founded in
                Amman with a bold vision and a deep understanding of smart
                living, we set out to make homes more intuitive, secure, and
                efficient. As demand grew, so did our footprint. From individual
                homeowners to large-scale developments, we’ve earned the trust
                of over 100 clients across Jordan and the UAE. Our journey has
                taken us from compact apartments to million-dollar residences,
                always with one mission: to simplify life through intelligent
                design. We don’t just install devices — we craft experiences.
                Our edge lies in our personalized routines, seamless
                integrations, and always-on support that keeps every system
                running smoothly. Whether you're starting small or going all-in,
                we’re here to superpower your space — with simplicity, security,
                and sustainability at the core.
              </>
            )}
          </p>
          <p style={{ marginBottom: "1.2rem" }}>
            {isAr ? (
              <>
                نخدم الأفراد والمشاريع العقارية على حد سواء — مع أكثر من{" "}
                <strong>١٠٠ عميل</strong> موثوق في الأردن والإمارات
              </>
            ) : (
              <>
                We serve individuals and large-scale projects alike—with over{" "}
                <strong>100 trusted clients</strong> in Jordan and the UAE.
              </>
            )}
          </p>
          <p>
            {isAr ? (
              <>نقدم تكاملًا ذكيًا وتجربة مصممة باحتراف</>
            ) : (
              <>We deliver smart integration and a crafted experience.</>
            )}
          </p>
        </div>
        <style>{`
          @keyframes fadeUp {
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .who-we-are-content {
            animation-delay: 0.1s;
          }
        `}</style>
      </section>

      <br />
      <br />
      <section style={{ padding: "3.2rem 1.5rem 2.2rem", marginTop: -12 }}>
        <h2 className="logo-gradient-title big-title">{t.journeyTitle}</h2>
        <div
          className={`journey-timeline-line${isAr ? " rtl" : ""}`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            overflowX: "auto",
            overflowY: "visible",
            maxWidth: "99vw",
            margin: "0 auto",
            paddingBottom: 32,
            paddingLeft: 10,
            paddingRight: 10,
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",
            scrollbarColor: "#2297e6 #dde7f7",
          }}
        >
          <div
            className="timeline-base-line"
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              top: "50%",
              width: "100%",
              height: 0,
              zIndex: 0,
              pointerEvents: "none",
            }}
          >
            <svg
              className="timeline-base-svg"
              width="100%"
              height="12"
              style={{ display: "block" }}
            >
              <line
                x1="2%"
                y1="6"
                x2="98%"
                y2="6"
                stroke="#2297e6"
                strokeWidth="10"
                strokeLinecap="round"
                opacity="0.13"
              />
            </svg>
            <svg
              className="timeline-base-svg-vertical"
              width="12"
              height="100%"
              style={{
                display: "none",
                position: "absolute",
                left: "50%",
                top: 0,
                bottom: 0,
                transform: "translateX(-50%)",
              }}
            >
              <line
                x1="6"
                y1="2%"
                x2="6"
                y2="98%"
                stroke="#2297e6"
                strokeWidth="10"
                strokeLinecap="round"
                opacity="0.13"
              />
            </svg>
          </div>
          <div
            className="journey-timeline-flex"
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "center",
              position: "relative",
              zIndex: 2,
              flexDirection: "row",
            }}
          >
            {t.milestones.map((m, idx) => (
              <React.Fragment key={m.year}>
                <div
                  className="journey-milestone"
                  style={{
                    background: darkMode ? "#232943" : lightBlueBG,
                    borderRadius: 20,
                    boxShadow: `0 2px 18px ${brandBlue}12`,
                    minWidth: 200,
                    maxWidth: 240,
                    flex: "0 0 220px",
                    padding: "2rem 1.2rem 1.5rem",
                    textAlign: "center",
                    borderBottom: `4px solid ${accentBlue}`,
                    margin: "0.7rem 0",
                    zIndex: 2,
                    scrollSnapAlign: "center",
                    position: "relative",
                    backgroundClip: "padding-box",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      color: darkMode ? "#fff" : brandBlue,
                      fontWeight: 800,
                      fontSize: "2.3rem",
                      letterSpacing: "-2px",
                    }}
                  >
                    {m.year}
                  </div>
                  <div
                    style={{
                      fontWeight: 700,
                      margin: "7px 0 9px",
                      fontSize: "1.14rem",
                    }}
                  >
                    {m.title}
                  </div>
                  <div
                    style={{
                      color: darkMode ? "#aad3ff" : "#3573c7",
                      fontSize: ".97rem",
                    }}
                  >
                    {m.desc}
                  </div>
                </div>
                {idx !== t.milestones.length - 1 && (
                  <div
                    className="journey-arrow-line"
                    style={{
                      width: 90,
                      minWidth: 60,
                      height: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      zIndex: 3,
                    }}
                  >
                    {!isAr ? (
                      <svg
                        className="arrow-horizontal"
                        width="90"
                        height="40"
                        viewBox="0 0 90 40"
                        style={{ display: "block" }}
                      >
                        <line
                          x1="5"
                          y1="20"
                          x2="80"
                          y2="20"
                          stroke={accentBlue}
                          strokeWidth="6"
                          strokeLinecap="round"
                        />
                        <polygon
                          points="80,10 90,20 80,30"
                          fill={accentBlue}
                          style={{
                            filter: "drop-shadow(0px 0px 2px #2297e688)",
                          }}
                        />
                      </svg>
                    ) : (
                      <svg
                        className="arrow-horizontal"
                        width="90"
                        height="40"
                        viewBox="0 0 90 40"
                        style={{ display: "block" }}
                      >
                        <line
                          x1="85"
                          y1="20"
                          x2="10"
                          y2="20"
                          stroke={accentBlue}
                          strokeWidth="6"
                          strokeLinecap="round"
                        />
                        <polygon
                          points="10,10 0,20 10,30"
                          fill={accentBlue}
                          style={{
                            filter: "drop-shadow(0px 0px 2px #2297e688)",
                          }}
                        />
                      </svg>
                    )}

                    <svg
                      className="arrow-vertical"
                      width="40"
                      height="90"
                      viewBox="0 0 40 90"
                      style={{ display: "none" }}
                    >
                      <line
                        x1="20"
                        y1="5"
                        x2="20"
                        y2="80"
                        stroke={accentBlue}
                        strokeWidth="6"
                        strokeLinecap="round"
                      />
                      <polygon
                        points="10,80 20,90 30,80"
                        fill={accentBlue}
                        style={{ filter: "drop-shadow(0px 0px 2px #2297e688)" }}
                      />
                    </svg>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
        <style>{`
          .journey-timeline-line {
            justify-content: center;
            scroll-snap-type: x mandatory;
          }
          .journey-timeline-flex {
            flex-direction: row;
          }
          .journey-timeline-line::-webkit-scrollbar {
            height: 8px;
          }
          .journey-timeline-line::-webkit-scrollbar-thumb {
            background: #2297e6;
            border-radius: 6px;
          }
          .journey-timeline-line::-webkit-scrollbar-track {
            background: #dde7f7;
            border-radius: 8px;
          }
          .journey-timeline-line.rtl {
            direction: rtl;
            flex-direction: row-reverse;
            justify-content: center;
          }
          .journey-timeline-line .journey-milestone {
            scroll-snap-align: center;
          }
          @media (max-width: 700px) {
            .timeline-base-line .timeline-base-svg {
              display: none !important;
            }
            .timeline-base-line .timeline-base-svg-vertical {
              display: block !important;
              height: 100vh !important;
              min-height: 300px;
            }
            .journey-timeline-flex {
              flex-direction: column !important;
              align-items: center !important;
            }
            .journey-timeline-line .journey-arrow-line {
              width: 40px !important;
              min-width: 24px !important;
              height: 90px !important;
            }
            .journey-arrow-line .arrow-horizontal {
              display: none !important;
            }
            .journey-arrow-line .arrow-vertical {
              display: block !important;
            }
          }
          .timeline-base-line {
            pointer-events: none;
          }
        `}</style>
      </section>

      <section
        style={{
          padding: "2.8rem 1.3rem 2.2rem",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1.2rem",
            flexWrap: "wrap",
          }}
        >
          <h2 className="logo-gradient-title big-title">{t.visionTitle}</h2>
        </div>
        <p
          className="vision-card"
          style={{
            maxWidth: 670,
            margin: "1.6rem auto 0",
            color: darkMode ? "#aad3ff" : accentBlue,
            fontWeight: 600,
            fontSize: "1.15rem",
            letterSpacing: ".02em",
            lineHeight: 1.7,
            borderRadius: 16,
            padding: "1.6rem 1.8rem",
            boxShadow: `0 4px 18px ${brandBlue}0a`,
            background: darkMode ? "#1a222f77" : undefined,
          }}
        >
          {t.visionText}
        </p>
      </section>

      <section
        style={{
          padding: "3.3rem 1.3rem 2.5rem",
          textAlign: "center",
          position: "relative",
        }}
      >
        <h2 className="logo-gradient-title big-title">{t.whyMass}</h2>
        <ul
          className="why-mass-list"
          style={{
            listStyle: "none",
            padding: 0,
            margin: "0 auto",
            maxWidth: 670,
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "2.2rem",
          }}
        >
          {t.whyMassPoints.map((point, idx) => (
            <li
              key={idx}
              style={{
                color: darkMode ? "#fff" : brandBlue,
                padding: "1.2rem 1.5rem",
                borderRadius: 16,
                minWidth: 230,
                maxWidth: 290,
                fontWeight: 600,
                boxShadow: `0 4px 24px ${brandBlue}13`,
                fontSize: "1.07rem",
                margin: "0.5rem",
                background: darkMode ? "#232943" : undefined,
              }}
            >
              <span
                style={{
                  color: darkMode ? "#6cb6f7" : accentBlue,
                  fontWeight: 800,
                  fontSize: "1.3em",
                  marginRight: isAr ? 0 : 8,
                  marginLeft: isAr ? 8 : 0,
                }}
              >
                ✓
              </span>
              {point}
            </li>
          ))}
        </ul>
      </section>

      <section style={{ padding: "3.2rem 1.5rem 2.2rem" }}>
        <h2 className="logo-gradient-title big-title">{t.diffTitle}</h2>
        <div
          className="different-cards"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2.5rem",
            flexWrap: "wrap",
          }}
        >
          {t.difference.map((d, i) => (
            <div
              key={d.title}
              style={{
                borderRadius: 14,
                minWidth: 200,
                maxWidth: 260,
                boxShadow: `0 2px 14px ${brandBlue}12`,
                padding: "2rem 1.1rem 1.3rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                margin: "0.7rem 0",
                background: darkMode ? "#232943" : undefined,
              }}
            >
              <span style={{ fontSize: "2.7rem", marginBottom: 13 }}>
                {d.icon}
              </span>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: "1.13rem",
                  color: darkMode ? "#fff" : brandBlue,
                  marginBottom: 7,
                }}
              >
                {d.title}
              </div>
              <div
                style={{
                  color: darkMode ? "#aad3ff" : "#3573c7",
                  fontSize: ".99rem",
                  textAlign: "center",
                }}
              >
                {d.desc}
              </div>
            </div>
          ))}
        </div>
      </section>

      <style>{`
        .logo-gradient-title {
          background: linear-gradient(90deg, #1a4bb7 0%, #2297e6 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-weight: 900;
          display: block;
          letter-spacing: .01em;
          text-align: center !important;
          margin-bottom: 28px;
          margin-top: 0;
        }
        .big-title {
          font-size: clamp(2.1rem, 6vw, 2.7rem) !important;
          line-height: 1.18;
        }
        @media (max-width: 1100px) {
          .about-hero-content {
            max-width: 99vw !important;
            padding: 1.3rem 0.5rem 1rem !important;
          }
          .journey-cards, .different-cards, .life-row {
            gap: 1.2rem !important;
          }
        }
        @media (max-width: 700px) {
          .about-hero-content {
            padding: 1.5rem 0.7rem 1rem !important;
            max-width: 99vw !important;
          }
          .about-hero-logo {
            height: 44px !important;
            margin-bottom: 10px !important;
          }
          .journey-cards, .different-cards, .life-row {
            flex-direction: column !important;
            gap: 1rem !important;
            align-items: stretch !important;
          }
          .journey-cards > div, .different-cards > div, .life-row > img {
            min-width: 0 !important;
            max-width: 99vw !important;
            width: 100% !important;
            margin-left: auto !important;
            margin-right: auto !important;
          }
          .life-row > div {
            margin-top: 1rem !important;
          }
          section, .about-hero {
            padding-left: 0.5rem !important;
            padding-right: 0.5rem !important;
          }
          .logo-gradient-title {
            font-size: 2.1rem !important;
          }
        }
        @media (max-width: 420px) {
          .about-hero-content {
            border-radius: 0 !important;
            font-size: 95% !important;
          }
        }
      `}</style>

      <style>{`
  .dark, .dark * {
    color: #fff !important;
  }
  .dark .journey-milestone,
  .dark .different-cards > div {
    background: #000 !important;
    box-shadow: 0 2px 14px #0008 !important;
    border: 2.5px solid #fff !important;
    border-radius: 18px !important;
    transition: border 0.2s;
  }
  .dark .vision-card {
    border: 2.5px solid #fff !important;
    background: #000 !important;
    color: #fff !important;
    border-radius: 18px !important;
    box-shadow: 0 2px 14px #0008 !important;
    transition: border 0.2s;
  }
  .dark .who-we-are-content {
    border: 2.5px solid #fff !important;
    background: #000 !important;
    color: #fff !important;
    border-radius: 18px !important;
    box-shadow: 0 2px 14px #0008 !important;
    transition: border 0.2s;
  }
  .dark .why-mass-list li {
    background: #000 !important;
    border: 2.5px solid #fff !important;
    border-radius: 18px !important;
    color: #fff !important;
    box-shadow: 0 2px 14px #0008 !important;
    transition: border 0.2s;
  }
`}</style>
    </main>
  );
};

export default AboutUsPage;
